/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

export { default as wrapPageElement } from "./wrapPageElement"

export const onClientEntry = () => {
  // IntersectionObserver polyfill (Safari, IE)
  if (typeof window.IntersectionObserver === `undefined`) {
    import(`intersection-observer`)
  }
}

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
  prevRouterProps,
}) => {
  const currentPosition = getSavedScrollPosition(location)

  if (!location.hash && prevRouterProps.location.hash !== "#globe") {
    window.scrollTo(...(currentPosition || [0, 0]))
  }

  return false
}
